import { createSelector } from 'reselect';

const stateSelector = (state) => state['templates'];

export const selectDataStructures = createSelector(stateSelector, (value) =>
  value && typeof value.toJS === 'function' ? value.toJS() : value
);
